import { render, staticRenderFns } from "./account_portfolio_chart.vue?vue&type=template&id=ffe329fa&"
import script from "./account_portfolio_chart.vue?vue&type=script&lang=js&"
export * from "./account_portfolio_chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports